import React, { Component } from "react";
import { withRouter } from "react-router";
import "../Product/product.scss";
import $ from "jquery";
import "floating-scroll/dist/jquery.floatingscroll.min.js";
import "floating-scroll/dist/jquery.floatingscroll.css";

class ProductList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            shipped: [],
            loaded: false,
            preY: 0,
            placeholder: "Loading",
            loading: false,
            option: 1
        };
        this.fetchData = this.fetchData.bind(this);
    }
    fetchData(refesh, option) {
        this.setState({ loading: true });
        let since_id = refesh ? 0 : (this.state.data.length == 0 ? 0 : this.state.data[this.state.data.length - 1].id);
        let url = "";
        switch (option) {
            case 1: 
                url = "/api/ProductList/" + since_id;
                break;
            case 2:
                url = "/api/ProductSearch/" + since_id;
                break;
        }
        console.log(url);
        fetch(url)
            .then((response) => {
                if (response.status > 400) {
                    return this.setState(() => {
                        return { placeholder: "Something went wrong!" };
                    });
                }
                return response.json();
            })
            .then((data) => {
                let shipped = [];
                data.orders.forEach((o) => {
                    let ns = 0;
                    o.fulfillments.forEach((s) => {
                        s.line_items.forEach((i) => {
                            ns += i.quantity;
                        });
                    });
                    shipped.push(ns);
                });
                if (refesh) {
                    this.setState(() => {
                        return {
                            data: data.orders,
                            shipped,
                            loaded: true,
                            loading: false,
                            option,
                            preY: 0
                        };
                    });
                } else {
                    this.setState(() => {
                        return {
                            data: [...this.state.data, ...data.orders],
                            shipped: [...this.state.shipped, ...shipped],
                            loaded: true,
                            loading: false,
                            option
                        };
                    });
                }
            });
    }
    handleObserver(entities, observer) {
        const y = entities[0].boundingClientRect.y;
        if (this.state.prevY > y) {
            this.fetchData(false, this.state.option);
            this.$el.floatingScroll("update");
        }
        this.setState({ prevY: y });
    }
    componentDidMount() {
        this.fetchData(true,1);

        var options = {
            root: null,
            rootMargin: "0px",
            threshold: 1.0,
        };

        this.observer = new IntersectionObserver(this.handleObserver.bind(this), options);
        this.observer.observe(this.loadingRef);
        this.$el = $(this.el);
        this.$el.floatingScroll("init");
    }
    componentWillUnmount() {
        this.$el.floatingScroll("destroy");
    }
    render() {
        const loadingCSS = {
            height: "100px",
            margin: "30px",
        };
        const loadingTextCSS = { display: this.state.loading ? "block" : "none" };
        return (
            <div>
                <div className="custom-main-title">Orders</div>
                <div className="card">
                    <div className="card-body custom-main-body">
                        <input className="form-control form-control-dark w-100 custom-order-search" type="text" placeholder="Search" aria-label="Search" />
                        <div className="custom-table-wrapper" ref={el => this.el = el}>
                            <table className="table table-striped table-hover custom-table">
                                <thead>
                                    <tr>
                                        <th>
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox" value="" id="cTop" />
                                            </div>
                                        </th>
                                        <th>Product</th>
                                        <th>Status</th>
                                        <th>Tags</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.data.map((item, idx) => {
                                        return (
                                            <tr
                                                onClick={() => {
                                                    window.open("https://dev-fame-plus.myshopify.com/admin/products/"+item.id);
                                                }}
                                            >
                                                
                                                <td>{item.image.src}</td>
                                                <td>
                                                    <div className="form-check">
                                                        <input className="form-check-input" type="checkbox" value="" id={"c" + item.id} />
                                                    </div>
                                                </td>
                                                <td>{item.title}</td>
                                                <td>{item.status}</td>
                                                <td>{item.tags}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                        <div ref={(loadingRef) => (this.loadingRef = loadingRef)} style={loadingCSS}>
                            <span style={loadingTextCSS}>Loading...</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default withRouter(ProductList);

